import { render, staticRenderFns } from "./UserTrainingHistoryQuestions.vue?vue&type=template&id=b6b2cd9e&"
import script from "./UserTrainingHistoryQuestions.vue?vue&type=script&lang=js&"
export * from "./UserTrainingHistoryQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports